export const COUNTRY_REGIONS: Record<string, { label: string; value: string }[]> = {
    GH: [
        { label: "Ahafo", value: "Ahafo" },
        { label: "Ashanti", value: "Ashanti" },
        { label: "Bono", value: "Bono" },
        { label: "Bono East", value: "Bono East" },
        { label: "Central", value: "Central" },
        { label: "Eastern", value: "Eastern" },
        { label: "Greater Accra", value: "Greater Accra" },
        { label: "North East", value: "North East" },
        { label: "Northern", value: "Northern" },
        { label: "Oti", value: "Oti" },
        { label: "Savannah", value: "Savannah" },
        { label: "Upper East", value: "Upper East" },
        { label: "Upper West", value: "Upper West" },
        { label: "Volta", value: "Volta" },
        { label: "Western", value: "Western" },
        { label: "Western North", value: "Western North" },
      ],
      
      NG: [
        { label: "Abia", value: "Abia" },
        { label: "Adamawa", value: "Adamawa" },
        { label: "Akwa Ibom", value: "Akwa Ibom" },
        { label: "Anambra", value: "Anambra" },
        { label: "Bauchi", value: "Bauchi" },
        { label: "Bayelsa", value: "Bayelsa" },
        { label: "Benue", value: "Benue" },
        { label: "Borno", value: "Borno" },
        { label: "Cross River", value: "Cross River" },
        { label: "Delta", value: "Delta" },
        { label: "Ebonyi", value: "Ebonyi" },
        { label: "Edo", value: "Edo" },
        { label: "Ekiti", value: "Ekiti" },
        { label: "Enugu", value: "Enugu" },
        { label: "Federal Capital Territory", value: "Federal Capital Territory" },
        { label: "Gombe", value: "Gombe" },
        { label: "Imo", value: "Imo" },
        { label: "Jigawa", value: "Jigawa" },
        { label: "Kaduna", value: "Kaduna" },
        { label: "Kano", value: "Kano" },
        { label: "Katsina", value: "Katsina" },
        { label: "Kebbi", value: "Kebbi" },
        { label: "Kogi", value: "Kogi" },
        { label: "Kwara", value: "Kwara" },
        { label: "Lagos", value: "Lagos" },
        { label: "Nasarawa", value: "Nasarawa" },
        { label: "Niger", value: "Niger" },
        { label: "Ogun", value: "Ogun" },
        { label: "Ondo", value: "Ondo" },
        { label: "Osun", value: "Osun" },
        { label: "Oyo", value: "Oyo" },
        { label: "Plateau", value: "Plateau" },
        { label: "Rivers", value: "Rivers" },
        { label: "Sokoto", value: "Sokoto" },
        { label: "Taraba", value: "Taraba" },
        { label: "Yobe", value: "Yobe" },
        { label: "Zamfara", value: "Zamfara" },
      ],
      
      ZA: [
        { label: "Eastern Cape", value: "Eastern Cape" },
        { label: "Free State", value: "Free State" },
        { label: "Gauteng", value: "Gauteng" },
        { label: "KwaZulu-Natal", value: "KwaZulu-Natal" },
        { label: "Limpopo", value: "Limpopo" },
        { label: "Mpumalanga", value: "Mpumalanga" },
        { label: "North West", value: "North West" },
        { label: "Northern Cape", value: "Northern Cape" },
        { label: "Western Cape", value: "Western Cape" },
      ],
  };
  
  export const getRegionsByCountryCode = (countryCode: string) =>
    COUNTRY_REGIONS[countryCode] ?? [];